import Toast from 'components/Shared/Toast';

export const printTicket = (key: string) => {
  const printContent = document.getElementById(`print-${key}`);
  if (!printContent) {
    Toast.error('Conteúdo para impressão não encontrado.');
    return;
  }

  const printTab = window.open('', '_blank');
  if (!printTab) {
    Toast.error('Não foi possível abrir a janela de impressão.');
    return;
  }

  printTab.document.write(`
      <html>
        <head>
          <title>Imprimir Ingresso</title>
          <style>
            body {
            font-family: roboto, arial, sans-serif;
            }
            .event-image {
              max-width: 140px;
              height: auto;
            }
            .event-title {
              font-size: 18px;
            }
            .event-info {
              display: flex;
              flex-direction: row;
            }
            .ticket-wrapper {
              display: flex;
              flex-direction: column;
              background: #ffffff;
              border: 1px solid #78909c;
              border-radius: 4px;
              margin-bottom: 16px;
              padding: 22px;
            }
            .text-wrapper {
              display: flex;
              flex-direction: column;
              gap: 8px;
            }
            .participant-info {
              display: flex;
              flex-direction: row;
              justify-content: space-between;
            }
          </style>
        </head>
        <body>
          ${printContent.innerHTML}
        <script>
            window.onload = function() {
              window.print();
            };
          </script>
        </body>
      </html>`);

  printTab.document.close();
};
